import { g as o } from "../_commonjsHelpers-ce4d82cc.js";
import "numbro";
function N(t) {
  return t == null;
}
var y = N;
const S = /* @__PURE__ */ o(y), k = (t = "") => String(t).replace(/[|\\{}()[\]^$+*?.]/g, "\\$&"), P = function(t, e) {
  e = e || "";
  const n = e.split(".");
  let r = t, i = null;
  for (let l = 0, s = n.length; l < s; l++) {
    const u = n[l];
    if (!r)
      break;
    if (l === s - 1) {
      i = r[u];
      break;
    }
    r = r[u];
  }
  return i;
}, W = (t, e) => {
  if (t === e)
    return !0;
  if (!(t instanceof Array) || !(e instanceof Array) || t.length !== e.length)
    return !1;
  for (let n = 0; n !== t.length; ++n)
    if (t[n] !== e[n])
      return !1;
  return !0;
};
function b(t) {
  let e = String(t), n = /e/.test(e), r = "";
  if (!n)
    return t;
  e.startsWith("-") && (e = e.replace("-", ""), r = "-");
  let i = !0;
  /e-/.test(e) && (i = !1);
  let l = Number(e.match(/\d+$/)[0]), s = e.match(/^[\d\.]+/)[0].replace(/\./, "");
  return i ? r + s.padEnd(l + 1, 0) : r + s.padStart(l + s.length, 0).replace(/^0/, "0.");
}
function $(t, e = {}) {
  if (S(t))
    return "0.00";
  if (Number.isNaN(Number(t)))
    return t;
  if (Number(t) === 0 && (e == null ? void 0 : e.mantissa) === void 0)
    return "0.00";
  t = b(t);
  const n = String(t).split(".");
  let r = n[0], i = n.length > 1 ? n[1] : "";
  if (i = i.replace(/0+?$/, ""), e != null && e.thousandSeparated && (r = r.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), e != null && e.mantissa)
    if (i.length < e.mantissa) {
      let l = new Array(e.mantissa - i.length).fill("0");
      i = i + l.join("");
    } else
      i.length > e.mantissa && (i = i.slice(0, e.mantissa));
  return e != null && e.forceSign && !r.startsWith("-") && !r.startsWith("+") && (r = "+" + r), i ? r + "." + i : r;
}
function E(t, e, n, r) {
  const { openCaseMode: i, ignorePattern: l, replaceAll: s, keyPlaceholderWord: u } = r;
  let f = u || "[(key)]", a = "";
  s && (a += "g"), i || (a += "i");
  const p = new RegExp(e, a);
  let g = [], h = 0;
  return l && (t = t.replace(l, function(c) {
    return g.push(c), `<<${h++}>>`;
  })), t = t.replace(p, function(c) {
    return n.replaceAll(f, c);
  }), l && (t = t.replace(/<<(\d+)>>/g, function(c, d) {
    return g[d];
  })), t;
}
export {
  k as escapeRegexpString,
  P as getValueByPath,
  $ as numberFormat,
  E as replaceString,
  b as scientificNumber,
  W as valueEquals
};
